import { parse, stringify } from 'query-string';

export default {
    data() {
        return {
            linkFilters: [],
        };
    },
    methods: {
        getQueryParams(query) {
            return parse(query, {
                parseNumbers: true,
                arrayFormat: 'comma',
            });
        },
        /**
         * @param initialFilters — инициальные фильтры
         */
        assignFiltersFromLink(initialFilters) {
            const linkParams = this.getQueryParams(window.location.search);
            const allowedFilters = Object.keys({
                ...this.store.filters, // разрешаем основные фильтры
            });
            const paginationKeys = Object.keys({ ...this.store.pagination }); // отдельно разрешаем пагинацию
            const linkFilters = Object.keys(linkParams);
            const pushedFilters = { ...initialFilters };
            const subject = Object.keys({
                ...this.store.filters.subject?.values,
            });
            const plot = Object.keys({ ...this.store.filters.plot?.values });
            const location = Object.keys({
                ...this.store.filters.location?.values,
            });
            const fo = Object.keys({ ...this.store.filters.fo?.values });
            const arr = window.location.pathname.split('/');

            arr.forEach((el) => {
                if (subject.includes(el)) {
                    pushedFilters.subject = el;
                } else if (plot.includes(el)) {
                    pushedFilters.plot = el;
                } else if (location.includes(el)) {
                    pushedFilters.location = el;
                } else if (fo.includes(el)) {
                    pushedFilters.fo = el;
                } else {
                    return false;
                }
            });
            const paginationValues = {};
            linkFilters.forEach((item) => {
                const filterName = item.split('-')[0];
                if (allowedFilters.includes(filterName)) {
                    if (linkParams[item] !== null && linkParams[item] !== '') {
                        pushedFilters[item] = linkParams[item];
                    }
                }
                if (paginationKeys.includes(filterName)) {
                    if (linkParams[item] !== null && linkParams[item] !== '') {
                        paginationValues[item] = linkParams[item];
                    }
                }
            });
            this.store.setLocalFilter(
                pushedFilters,
                paginationValues,
                this.filtersData
            );
            this.linkFilters = pushedFilters;
        },
        /**
         * Конветирует фильтр в объект [ключ]: значение
         * @param filter
         */
        convertToKeyValue(filter) {
            if (
                filter.value === null ||
                filter.value === undefined ||
                (Array.isArray(filter.value) && !filter.value.length)
            ) {
                return null;
            }
            if (['select'].includes(filter.type)) {
                return { [filter.name]: filter.value[0].value };
            }
            if (['radio'].includes(filter.type)) {
                if (Array.isArray(filter.value)) {
                    const valuesList = filter.value.map((item) => item.value);
                    return { [filter.name]: valuesList };
                }
                return { [filter.name]: filter.value.value };
            }
            if (['select-multiple'].includes(filter.type)) {
                const itemValues = [];
                filter.value.forEach((item) => {
                    itemValues.push(item.value);
                });
                return { [filter.name]: itemValues };
            }
            if (['minmax'].includes(filter.type)) {
                return {
                    [`${filter.name}-from`]: filter.value[0],
                    [`${filter.name}-to`]: filter.value[1],
                };
            }
            if (['date'].includes(filter.type)) {
                if (Array.isArray(filter.value) && filter.auction) {
                    return {
                        [`${filter.name}-auction-from`]: filter.value[0],
                        [`${filter.name}-auction-to`]: filter.value[1],
                    };
                }
                if (Array.isArray(filter.value) && !filter.auction) {
                    return {
                        [`${filter.name}-from`]: filter.value[0],
                        [`${filter.name}-to`]: filter.value[1],
                    };
                }
                return {
                    [`${filter.name}-from`]: filter.value,
                    [`${filter.name}-to`]: filter.value,
                };
            }
            if (
                ['text', 'checkbox'].includes(filter.type) &&
                filter.value &&
                typeof filter.value === 'string' &&
                filter.value.length
            ) {
                return { [filter.name]: filter.value };
            }
        },
        updateFiltersURI() {
            const filters = { ...this.store.localFilters };
            const pagination = { ...this.store.pagination };
            let pathname;
            pathname = window.location.pathname;
            if (this.$options.name === 'AuctionsListPage') {
                pathname = '/auctions/';
                if (typeof this.filtersData === 'object') {
                    const pathParams = [];
                    const allLocation = this.store.filters.location.structure;
                    const foLocation = this.store.filters.fo.values;
                    const filterLocation = this.store.localFilters.location;
                    let filteredLocation = null;

                    // Цикл по всем ФО
                    for (let fo in allLocation) {
                        // Получаем массив регионов для текущего ФО
                        const region = Object.keys(allLocation[fo]);
                        // Проверяем совпадение массивов
                        const isEqual =
                            filterLocation?.length === region?.length &&
                            filterLocation.every((key) => region.includes(key));

                        if (isEqual) {
                            // Ищем соответствующий ключ ФО
                            filteredLocation =
                                Object.keys(foLocation).find(
                                    (key) => foLocation[key] === fo
                                ) || null;
                            break; // Прерываем цикл, так как нашли совпадение
                        }
                    }

                    if (filteredLocation) {
                        delete filters.location;
                        // Параметр fo для api url, для получения корректного заголовка(Список аукционов ...)
                        this.store.localFilters.fo = filteredLocation;
                        pathParams.push(filteredLocation);
                    }
                    // end ФО со всеми выбранными регионами

                    const filtersReplaceUrl = ['location', 'plot', 'subject'];

                    // Смотри что за параметры добавили
                    let replacedFiltersCount = 0;
                    let replacedFilters = [];

                    for (const paramName of filtersReplaceUrl) {
                        let findValue = null;

                        // Если добавили уже 2 параметра останавливаемся
                        if (replacedFiltersCount >= 2) break;

                        if (paramName === 'location') {
                            if (typeof filters.location === 'object') {
                                if (
                                    Object.keys(filters.location).length === 1
                                ) {
                                    findValue = filters.location[0].toString();
                                }
                            } else if (filters.location) {
                                findValue = filters.location.toString();
                            }

                            if (findValue === 'none') {
                                filters.location =
                                    this.store.localFilters.location;
                            }

                            if (
                                findValue &&
                                this.filtersData.location.url[findValue] &&
                                replacedFiltersCount < 2 &&
                                // Запрет на добавление и вида объекта и типа реализации вместе
                                !(
                                    paramName === 'plot' &&
                                    replacedFilters.includes('subject')
                                ) &&
                                !(
                                    paramName === 'subject' &&
                                    replacedFilters.includes('plot')
                                )
                            ) {
                                pathParams.push(
                                    this.filtersData.location.url[findValue]
                                );
                                delete filters.location;
                                replacedFiltersCount++;
                                replacedFilters.push(paramName);
                            }
                        } else {
                            if (typeof filters[paramName] === 'object') {
                                if (
                                    Object.keys(filters[paramName]).length === 1
                                ) {
                                    findValue =
                                        filters[paramName][0].toString();
                                }
                            } else if (filters[paramName]) {
                                findValue = filters[paramName].toString();
                            }
                            if (
                                findValue &&
                                replacedFiltersCount < 2 &&
                                // Запрет на добавление и вида объекта и типа реализации вместе
                                !(
                                    paramName === 'plot' &&
                                    replacedFilters.includes('subject')
                                ) &&
                                !(
                                    paramName === 'subject' &&
                                    replacedFilters.includes('plot')
                                )
                            ) {
                                pathParams.push(findValue);
                                delete filters[paramName];
                                replacedFiltersCount++;
                                replacedFilters.push(paramName);
                            }
                        }
                    }

                    if (pathParams.length > 0) {
                        pathname = `/auctions/${pathParams.join('/')}/`;
                    }
                }
                if (
                    filters.type.length &&
                    filters.type.includes('auctions') &&
                    filters.type.includes('agency')
                ) {
                    delete filters.type;
                }
            }

            if (pagination.page === 1) {
                delete pagination.page;
            }

            if (pagination['page-size'] === 8) {
                delete pagination['page-size'];
            }
            let urlParams = stringify(
                {
                    ...filters,
                    ...pagination,
                },
                { arrayFormat: 'comma' }
            );
            if (urlParams.length > 0) {
                urlParams = `?${urlParams}`;
            }
            window.history.replaceState(
                null,
                null,
                `${window.location.origin + pathname}${urlParams}`
            );
            this.store.setURLParams(pathname + urlParams);
        },
    },
};
